import React from "react";

import { SkipLogicConditionCreateDto } from "@common/components/skip-logic/skip-logic.types";
import { SkipLogicCondition } from "@common/components/skip-logic/skip-logic.types";
import { Row } from "./components/row";

import "./body.styles.scss";

type SkipLogicBodyProps = {
  conditions: SkipLogicCondition[];
  selectedConditionId?: SkipLogicCondition['id'];
  onConditionClick: (condition: SkipLogicCondition) => void;
  columns: Array<{
    label: string;
    fieldName: keyof SkipLogicConditionCreateDto;
    component: (condition: SkipLogicCondition) => React.ReactNode;
  }>;
  enableDragDrop?: boolean;
  onRowDrop?: (dragIndex: number, hoverIndex: number) => void;
};

export const SkipLogicBody: React.FC<SkipLogicBodyProps> = ({
  conditions,
  selectedConditionId,
  onConditionClick,
  columns,
  enableDragDrop = false,
  onRowDrop,
}) => {
  return (
    <tbody className="SkipLogic__table-body">
      {conditions.map((condition, conditionIndex) => (
        <Row
          selectedRow={selectedConditionId === condition.id}
          onClick={onConditionClick}
          key={condition.id}
          condition={condition}
          conditionIndex={conditionIndex}
          columns={columns}
          enableDragDrop={enableDragDrop}
          onRowDrop={onRowDrop}
        />
      ))}
    </tbody>
  );
};
